import { styled } from '@glitz/react';
import * as style from 'Shared/Style';

export const AspectRatioOuter = styled.div({
  height: '0px',
  overflow: 'hidden',
  position: 'relative',
});

export const AspectRatioInner = styled.div({
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
});

export const HoverAspectRatioInner = styled.div({
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  borderRadius: '8px',
  border: {
    xy: {
      style: 'solid',
      width: '1px',
      color: 'transparent',
    }
  },
  transition: {
    property: 'border',
    duration: '0.3s',
    timingFunction: 'linear'
  },
  ':hover': {
    border: {
      xy: {
        style: 'solid',
        width: '1px',
        color: style.colors.monochrome.black,
      }
    }
  }
});

export const OverlayNotABackdrop = styled.div({
  //May require wrapping in a div with position: relative
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
});
